import { CONTACT_US_IF_FURTHER_HELP, getAccountSettingsCTA } from "./shared";
export var PasswordIA = function PasswordIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getAccountSettingsCT;
        return (_getAccountSettingsCT = getAccountSettingsCTA(context, strictLocalize)) === null || _getAccountSettingsCT === void 0 ? void 0 : _getAccountSettingsCT.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getAccountSettingsCT2, _getAccountSettingsCT3;
        return (_getAccountSettingsCT2 = getAccountSettingsCTA(context, strictLocalize)) === null || _getAccountSettingsCT2 === void 0 ? void 0 : (_getAccountSettingsCT3 = _getAccountSettingsCT2.getLink) === null || _getAccountSettingsCT3 === void 0 ? void 0 : _getAccountSettingsCT3.call(_getAccountSettingsCT2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UPDATE_PASSWORD_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [UPDATE_PASSWORD_DESCRIPTION_1(strictLocalize), UPDATE_PASSWORD_DESCRIPTION_2(strictLocalize), CONTACT_US_IF_FURTHER_HELP(strictLocalize)];
    }
  };
};
var UPDATE_PASSWORD_TITLE = function UPDATE_PASSWORD_TITLE(strictLocalize) {
  return strictLocalize({
    id: "GwoAYn",
    defaultMessage: [{
      "type": 0,
      "value": "Atualizar palavra-passe"
    }]
  });
};
var UPDATE_PASSWORD_DESCRIPTION_1 = function UPDATE_PASSWORD_DESCRIPTION_1(strictLocalize) {
  return strictLocalize({
    id: "uaYTsO",
    defaultMessage: [{
      "type": 0,
      "value": "Se desejar redefinir a sua palavra-passe, siga os passos abaixo:"
    }]
  });
};
var UPDATE_PASSWORD_DESCRIPTION_2 = function UPDATE_PASSWORD_DESCRIPTION_2(strictLocalize) {
  return strictLocalize({
    id: "YlT1uf",
    defaultMessage: [{
      "type": 0,
      "value": "Clique no botão Iniciar sessão no canto superior direito da página inicial. Introduza o endereço de e-mail de início de sessão e prima Enter no ecrã seguinte. Clique no link \"Esqueceu-se da palavra-passe? Redefina-a\"."
    }]
  });
};